import { render, staticRenderFns } from "./OpeningHoursDetails.vue?vue&type=template&id=2c071b03&scoped=true"
import script from "./OpeningHoursDetails.vue?vue&type=script&lang=js"
export * from "./OpeningHoursDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c071b03",
  null
  
)

export default component.exports